import React, {useState} from 'react';
import AppSideLayout from '../../components/layouts/AppSideLayout';
import {Button, Card, Input, message, Space, Tooltip} from 'antd';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import {UserAddOutlined, HomeOutlined} from '@ant-design/icons';
import './register.less';
import CountDownButton from '../../components/CountDownButton';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {SavePersonalApproveParams, UserApi} from '../../scaffold';
import {useInput} from 'react-hanger';
import PersonalApproveTable from '../../components/user/PersonalApproveTable';
import useAuth from '../../utils/AuthContext';
import {Delay} from '../../utils/delay';
import {useHistory} from 'react-router-dom';
export function Label(props: {required?: boolean; children?: any}) {
  return (
    <Space>
      {props.children}
      {props.required && <Text type={'danger'}>*</Text>}
    </Space>
  );
}
export default function RegisterPage() {
  const [type, _type] = useState<'个人' | '团体'>();
  const requestSms = useOpenApiFpRequest(UserApi, UserApi.prototype.userRequestSmsCodePost);
  const register = useOpenApiFpRequest(UserApi, UserApi.prototype.userRegisterPost);
  const telephone = useInput('');
  const password = useInput('');
  const passwordAgain = useInput('');
  const code = useInput('');
  const [loading, _loading] = useState(false);
  const auth = useAuth();
  const history = useHistory();
  const savePersonalApprove = useOpenApiFpRequest(UserApi, UserApi.prototype.userSavePersonalApprovePost);

  async function registerSubmit() {
    const res = await register.request({
      registerParams: {
        telephone: telephone.value,
        password: password.value,
        passwordAgain: passwordAgain.value,
        code: code.value,
      },
    });
    if (res.user) {
      auth.setCurrentUser(res.user);
      auth.setToken(res.body || '');
      localStorage.setItem('Application-Token', res.body || '');
      return res;
    }
    throw new Error('注册失败');
  }

  async function onSubmitPersonalApprove(params: SavePersonalApproveParams) {
    _loading(true);
    try {
      if (!auth.currentUser) {
        const res = await registerSubmit();
        params.userId = res.user?.id || 0;
      } else {
        params.userId = auth.currentUser?.id || 0;
      }
      const user = await savePersonalApprove.request({savePersonalApproveParams: params});
      auth.setCurrentUser(user);
      message.success('申请已提交');
      history.push('/profile/detail');
    } catch (e) {
      message.error(e.message);
    }
    _loading(false);
  }

  return (
    <AppSideLayout title={'在线入会'}>
      <Card style={{flex: 1}} title={'在线入会'}>
        {!type && (
          <div className={'text-center p-20'}>
            <Title level={4} className={'m-b-20'}>
              请选择入会申请表
            </Title>
            <Space>
              <Button className={'RegisterBtn RegisterBtnPersonal'} onClick={() => _type('个人')}>
                <div>
                  <UserAddOutlined />
                  <div>个人会员入会</div>
                </div>
              </Button>
              <Button
                className={'RegisterBtn RegisterBtnDouble'}
                onClick={() => {
                  history.push('/about/doubleSelectRegister');
                }}>
                <div>
                  <UserAddOutlined />
                  <div>双选会员激活</div>
                </div>
              </Button>
              <Tooltip title={'该功能正在维护中'}>
                <Button className={'RegisterBtn RegisterBtnOrganization'}>
                  <HomeOutlined />
                  <div>团体会员入会</div>
                </Button>
              </Tooltip>
            </Space>
          </div>
        )}
        {!!type && (
          <div className={'p-20 text-center'}>
            {type === '个人' && (
              <Title level={4} className={'m-b-20'}>
                上海市计算机学会个人会员 <br />
                入会申请书
              </Title>
            )}
            {!auth.currentUser && (
              <table className={'RegisterTable'}>
                <tr>
                  <td width={110}>
                    <Label required>手机号</Label>
                  </td>
                  <td width={229}>
                    <Input placeholder={'输入 11 位手机号'} prefix={'+86'} {...telephone.eventBind} />
                  </td>
                  <td width={130}>
                    <Label required>验证码</Label>
                  </td>
                  <td>
                    <Space style={{width: '100%'}}>
                      <Input placeholder={'请输入短信验证码'} {...code.eventBind} />
                      <CountDownButton
                        title={'立即获取'}
                        loading={requestSms.loading}
                        onClick={() => requestSms.request({requestSmsCodeParams: {telephone: telephone.value}})}
                        countDown={60}
                      />
                    </Space>
                  </td>
                </tr>
                <tr>
                  <td width={110}>
                    <Label required>密码</Label>
                  </td>
                  <td width={229}>
                    <Input.Password {...password.eventBind} />
                  </td>
                  <td width={130}>
                    <Label required>确认密码</Label>
                  </td>
                  <td>
                    <Input.Password {...passwordAgain.eventBind} />
                  </td>
                </tr>
              </table>
            )}
            {type === '个人' && <PersonalApproveTable onSubmit={onSubmitPersonalApprove} loading={loading} />}
          </div>
        )}
      </Card>
    </AppSideLayout>
  );
}
